import React, { useContext } from 'react'
import SbEditable from 'storyblok-react'
import Heading from 'src/components/Heading'
import Label from 'src/components/Label'
import RichText from 'src/utils/RichText'
import FormatDate from 'src/utils/FormatDate'
import { PageContext } from 'src/utils/context'
import BackButton from './BackButton'
import Share from './Share'
import Author from '../Author'

const Content = ({ blok }) => {

    const context = useContext(PageContext)

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white px-6">
                <div className={`max-w-6xl px-6 mx-auto lg:!my-24 !my-12 ${blok.disable_back_button && '!mt-6'}`}>
                    {!blok.disable_back_button &&
                        <BackButton component={context.content.component}/>
                    }
                    {!blok.disable_date &&
                        <Label className="text-lightblue-300 !mb-6">
                            {context.first_published_at ? FormatDate(context.first_published_at):""}
                            {context.content?.location ? ` · Location: ${context.content?.location}`: ''}
                        </Label>
                    }
                    {!blok.disable_title &&
                        <Heading size="h2" className="!mb-14 text-darkblue">{context.name}</Heading>
                    }
                    <div className="font-display prose prose-headings:mb-4 prose-li:prose-ul:marker:text-brightgreen prose-headings:mt-0 prose-img:rounded-md prose-hr:border-lightblue-600 text-darkblue-700">
                        <RichText>{blok.content}</RichText>
                    </div>
                   {blok?.Author&& <Author uuid={blok.Author} color={blok.color}/>}
                    {!blok.disable_share_icons &&
                        <Share currentUrl={context.location.pathname} title={context.name}/>
                    }
                </div>
            </div>
        </SbEditable>
    )
}

export default Content